// import React, { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
// import ChartContainer from './ChartContainer';
// import DataTableContainer from './DataTableContainer';

// export default function ReportWidjet(props) {
//     const [widgetName, setWidgetName] = useState(props.widjetName)
//     const selectedWidget = useSelector(state => state?.editor?.selectedResource?.widjet || null)
//     useEffect(() => {
//         if (selectedWidget && selectedWidget === props.activeWidgetName) {
//             setWidgetName(props.activeWidgetName)
//         }
//     }, [props.activeWidgetName, selectedWidget])

//     return (
//         <>
//             {props?.reportData ?
//                 <div style={{ position: 'absolute', width: '100%' }}>
//                     {(() => {
//                         switch (widgetName) {
//                             case 'table':
//                                 return (
//                                     <DataTableContainer reportData={props.reportData} availableFields={props.availableFields} allFields={props.allFields} dataFilters={props.dataFilters} aggRowBuilders={props.aggRowBuilders} aggregation={props.aggregation} aggGroupBuilders={props.aggGroupBuilders} groupedReportData={props.groupedReportData} selectedResourceId={props.selectedResourceId} applyFilters={props.applyFilters} drillDowns={props.drillDowns} />
//                                 );
//                             case 'chart':
//                                 return (
//                                     <ChartContainer reportData={props.reportData?.Result || props.reportData} availableFields={props.availableFields} dataFilters={props.dataFilters} aggRowBuilders={props.aggRowBuilders} aggregation={props.aggregation} charts={props.charts} selectedWidgetName={props.selectedWidgetName} selectedResourceId={props.selectedResourceId} applyFilters={props.applyFilters} />
//                                 );
//                             default:
//                                 return (
//                                     <div>
//                                         blank widjet
//                                     </div>
//                                 )
//                         }
//                     })()}

//                 </div>
//                 : <div>XXXX</div>}
//         </>

//     )
// }

import React, { memo } from "react";
import ChartContainer from "./ChartContainer";
import DataTableContainer from "./DataTableContainer";
import { returnDataArrayObject } from "../../../utils/arrayHelper";
import "./ReportWidjet.css";

const ReportWidjet = memo(function ReportWidjet(props) {
  /* Each canvas item renders the type it was dropped as (`component`, also restored from
     the saved board). It used to be overwritten from the resource-level `widjet`:

       const selectedWidget = useSelector(s => s.editor.selectedResource.widjet)
       useEffect(() => { if (selectedWidget === props.activeWidgetName) setWidgetName(...) })

     which meant clicking a chart type in Insert CONVERTED every widget already on the
     canvas for that resource instead of arming the next drop - a dropped table turned
     into "Chart not configured" and its data disappeared. A dashboard has to be able to
     hold a table and a chart side by side, so the item's own type wins. */
  const widgetName = props.widjetName;

  // ── derive chart config from either live redux charts or layout-item charts ──
  const chartConfig = props.charts;
  const hasChartConfig = chartConfig && chartConfig.chartType && chartConfig.fieldName && chartConfig.groupBy;

  return (
    <>
      {props?.reportData ? (
        <div
          className={
            widgetName === "chart" ? "widget-content widget-content--chart" : "widget-content widget-content--table"
          }
        >
          {(() => {
            switch (widgetName) {
              case "table":
                return (
                  <DataTableContainer
                    reportData={props.reportData}
                    availableFields={props.availableFields}
                    allFields={props.allFields}
                    dataFilters={props.dataFilters}
                    aggRowBuilders={props.aggRowBuilders}
                    aggregation={props.aggregation}
                    aggGroupBuilders={props.aggGroupBuilders}
                    groupedReportData={props.groupedReportData}
                    selectedResourceId={props.selectedResourceId}
                    applyFilters={props.applyFilters}
                    drillDowns={props.drillDowns}
                  />
                );

              case "chart":
                // ── guard: show placeholder if chart not configured ──
                if (!hasChartConfig) {
                  return (
                    <div className="chart-not-configured">
                      <div className="chart-not-configured-inner">
                        <span className="chart-not-configured-icon">📊</span>
                        <p className="chart-not-configured-title">Chart not configured</p>
                        <p className="chart-not-configured-desc">Set fields in the Chart section and click Apply</p>
                      </div>
                    </div>
                  );
                }
                return (
                  <ChartContainer
                    /* ── ALWAYS AN ARRAY ───────────────────────────────────────────
                       ChartContainer feeds this straight into groupBy, which reduces
                       over it. It must be an array or the editor dies on render.

                       This used to read `props.reportData?.Result || props.reportData`,
                       which is fine only while the response HAS a populated Result. A
                       resource whose API answers `{ Status: true, Result: null }` -
                       which is exactly what one returns when its date parameters are
                       left empty - fell through the `||` to the raw response OBJECT,
                       and `object.reduce is not a function` took the whole editor down
                       behind the error boundary. Opening a report to fix its dates was
                       impossible for that reason.

                       returnDataArrayObject answers every shape with `{ data: [...] }`:
                       a bare array, `{Result: [...]}`, a two-period `{Result, Result2}`,
                       and a null or text response (an empty array). So there is no
                       longer a response that can be handed here as anything but rows. */
                    reportData={returnDataArrayObject(props.reportData).data}
                    availableFields={props.availableFields}
                    dataFilters={props.dataFilters}
                    aggRowBuilders={props.aggRowBuilders}
                    aggregation={props.aggregation}
                    charts={chartConfig}
                    selectedWidgetName={props.selectedWidgetName}
                    selectedResourceId={props.selectedResourceId}
                    applyFilters={props.applyFilters}
                  />
                );

              default:
                return <div>blank widjet</div>;
            }
          })()}
        </div>
      ) : (
        <div>XXXX</div>
      )}
    </>
  );
});

export default ReportWidjet;
